import styled from 'styled-components'
import { TagsContainer } from '../blog/blogPost/style'

export const ResourceDemoTagsContainer = styled(TagsContainer)`
  max-width: 548px;
  margin-left: auto;
  margin-right: auto;
`
